import { useTheme } from "@mui/material";
import zIndex from "@mui/material/styles/zIndex";
import { useCheckViewPoint, VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { useEffect } from "react";
import useLayoutConfigStore from "store/layout-config-store/useLayoutConfigStore";
import { BackButton } from "v2/components/base/Button/ui";
import { Col, Row } from "v2/components/base/Flex/ui";
import { ViewPoint } from "v2/components/base/ResponsiveLayout/ui";

const SubPageLayout = ({
  handleBack,
  backToTitle = "Back",
  children,
}: {
  handleBack: () => void;
  backToTitle: string;
  children: React.ReactNode;
}) => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);
  const { setIsShowFooter } = useLayoutConfigStore();

  useEffect(() => {
    if (isMobile) {
      setIsShowFooter(false);
    }

    return () => {
      setIsShowFooter(true);
    };
  }, [isMobile]);

  return (
    <Col
      type="ss"
      sx={{
        ...(!isMobile && {
          position: "fixed",
          top: "0",
          left: "0",
        }),
        marginLeft: !isMobile ? "20%" : "0",
        width: !isMobile ? "80%" : "100%",
        overflowY: "hidden",
      }}
      fullHeight
      fullWidth>
      <ViewPoint.Mobile>
        <Col
          sx={{
            backdropFilter: "blur(40px)",
            gap: "32px",
            overflowY: "scroll",
          }}
          fullWidth>
          <Row type="bs" fullWidth fullHeight>
            {children}
          </Row>
        </Col>
      </ViewPoint.Mobile>
      <ViewPoint.Desktop>
        <Col
          sx={{
            backdropFilter: "blur(40px)",
            marginX: "auto",
            gap: "32px",
            // maxHeight: "100vh",
            maxWidth: "1200px",
            padding: "24px",
          }}
          fullWidth
          fullHeight>
          <Row type="bs" fullWidth>
            <BackButton title={backToTitle} onClick={handleBack} />
          </Row>
          <Row type="bs" fullWidth fullHeight>
            {children}
          </Row>
          <Row type="bs" fullWidth sx={{ height: "100px" }} />
        </Col>
      </ViewPoint.Desktop>
    </Col>
  );
};

export default SubPageLayout;
